module.exports = __webpack_public_path__ + "static/5-b9fcbcd50694e6efef11be8b3925276e.png";